const getters = {
    user: state => state.authModule.user,
    token: state => state.authModule.token,
    menuTree: state => state.authModule.menuTree,
    addRouters: state => state.permission.addRouters,
    routers: state => state.permission.routers,
    mapPermission(state){
        let obj={}
        state.permission.permissionList.map(i=>i.permission).forEach(i=>{
           obj[i]=true
        })
        return  obj
    },
    checkedList: state => state.common.serverProject.checkedList,
    checkedPeople: state => state.common.serverProject.checkedPeople,
};
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js